import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;

export interface ChatMessageParams {
  role: string;
  content: string;
}

export const chatApi = {
  /**
   * @description opeAi 接口调用。可选传 tools 启用 function calling（网关支持）。
   * messages 用 any[]：工具循环里会追加带 tool_calls 的 assistant 消息与 role:"tool" 消息，
   * 结构比 ChatMessageParams 更宽。
   */
  chat(
    messages: ChatMessageParams[] | any[],
    tools?: any[],
    conversationId?: string,
    persistMessages?: any[],
  ): Promise<any> {
    return request({
      method: 'POST',
      // 经 mfd 后端代理调大模型网关；token/model 后端注入，前端不持密钥，自动带 utoken 鉴权。
      // 返回原样透传网关 OpenAI 兼容结构（res.choices...），temperature/max_tokens 等由后端固定。
      url: 'api/v1/ai/robot/chat',
      timeout: 3 * 60 * 1000,
      data: {
        messages,
        // 会话ID：同一会话多轮/工具循环共用，供后端按会话归组留存对话；不传则后端兜底生成。
        ...(conversationId ? { conversation_id: conversationId } : {}),
        // 留存用消息：结构同 messages，但图片 base64 已换成 OSS URL（图已上传私有桶）。
        // 仅后端落库用，发网关仍用 messages（base64）；无图时不传，后端退回 messages。
        ...(persistMessages && persistMessages.length ? { persist_messages: persistMessages } : {}),
        ...(tools && tools.length ? { tools, tool_choice: 'auto' } : {}),
      },
    });
  },
};
